import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

import { query, where, collection, getDocs, doc, getDoc, onSnapshot, collectionGroup } from "firebase/firestore";
import { db } from "../firebase.js";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet";
import './services.css';
import { Toast } from '../components_root/ToastContext';
import { Get_website_information } from '../website_root/get_website_information.js';
import { Verify_stafftype_account } from "../company_root/staff_account_root/verify_stafftype_account.js";
import { Get_company_information } from '../company_root/get_company_information.js';
import {
    MdCall, MdPictureAsPdf, MdFace, MdEditDocument,
    MdKeyboard
} from "react-icons/md";

export const seo = {
    title: "Aooz — Accounting Online Operations Zone",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};


export default function Services() {

    const [companydata, setCompanydata] = useState([]);
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [servicesdata, setServicesdata] = useState([]);
    const [select_company_uid, setselect_company_uid] = useState();

    //staff account verify
    const [staffstatus, setStaffstatus] = useState(false);
    const [staffdata, setStaffdata] = useState([]);
    useEffect(() => {
        setselect_company_uid(Cookies.get("select_company_uid"));
    }, []);

    const [accountcompanydata, setaccountcompanydata] = useState([]);

    useEffect(() => {
        const searchStaff = async () => {
            const accountguid = Cookies.get("guid");
            if (!accountguid) return;
            const companiesRef = collection(db, "companies");
            const companiesSnap = await getDocs(companiesRef);
            const companyUids = [];
            for (const companyDoc of companiesSnap.docs) {
                const companyUid = companyDoc.id; 
                const staffRef = collection(
                    db,
                    "companies",
                    companyUid,
                    "staff_accounts"
                );
                const q = query(
                    staffRef,
                    where("accountguid", "==", accountguid)
                );
                const staffSnap = await getDocs(q);
                if (!staffSnap.empty) {
                    companyUids.push(companyUid);
                }
            }
            if (companyUids.length > 0) {
                setaccountcompanydata(companyUids); 
                //  ✅ FIX: use local variable, not state
                if (companyUids.length === 1) {
                    Cookies.set(
                        "select_company_uid",
                        companyUids[0],
                        { expires: 365, path: "/" }
                    );
                }
            }
        }; 
        searchStaff();
    }, []);
    useEffect(() => { 
        const verifyStaffAccount = async () => {
            const accountguid = Cookies.get("guid");
            const result = await Verify_stafftype_account(accountguid);
            if (result.success) {
                setStaffdata({
                    staff: result.data,
                    accountinfo: result.accountinfo
                });
                setStaffstatus(true);
            } else {

            }
        };
        verifyStaffAccount();
    }, []);
    useEffect(() => {
        if (
            staffstatus === true &&
            staffdata?.staff?.account_type === "admin"
        ) {
            const loadCompany = async () => {
                const res = await Get_company_information("company");
                if (res.success) {
                    setCompanydata(res.data);
                }
            }; 
            loadCompany();
        }
    }, [staffstatus, staffdata]);
    useEffect(() => {
        const load = async () => {
            // First: initial load
            const initialQuery = query(collection(db, "servicesdb"),
                where("public_type", "==", true));
            const initialSnap = await getDocs(initialQuery); 
            if (!initialSnap.empty) {
                const initialData = initialSnap.docs.map(d => ({
                    id: d.id,
                    ...d.data(),
                }));
                setServicesdata(initialData);
            }

        };

        load();
    }, []);

    return (
        <div>
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>
            <div className="container_roots">

                <div className="container_size p-3">
                    <h2 className="text-xl font-bold mb-4">Products & Services
                    </h2>
                    <div className='post-container'>
                        <div className="ui-grid-100">
                            {companydata?.slug && (
                                <div
                                    className="ui-items center cursor"
                                    onClick={() => navigate("/company")}
                                >
                                    <img
                                        src={companydata.logo_url}
                                        alt={companydata.slug}
                                        className="service_photo hover items-back rounded shadow"
                                    />

                                    <div className="text-h2 bold fcap p-1 cursor">
                                        {companydata.slug}
                                    </div>
                                </div>
                            )}

                            {servicesdata.map(row => (
                                <div
                                    key={row.id}
                                    className="ui-items center cursor"
                                    onClick={() => {
                                        if (staffstatus === true) {
                                            if (staffdata?.staff?.account_type === "admin") {
                                                navigate(`/${row.url}`);
                                            } else {
                                                navigate(`/${row.slug}`);
                                            }
                                        } else {
                                            navigate(`/${row.url}`);
                                        }
                                    }}
                                >
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td >
                                                    <img src={row.logo_url} className="service_photo hover items-back rounded shadow" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div

                                        className="text-h2 bold fcap p-1 cursor"
                                    >
                                        {row.slug}
                                    </div>

                                </div>
                            ))}

                        </div>

                    </div>

                </div>

                <div className="container_size p-3">
                    <h2 className="text-xl font-bold mb-4">Free Tools</h2>
                    <div className='post-container'>
                        <div className='ui-grid-100'>

                            <div onClick={() => navigate('/phonebook')} className="ui-items hover-u items-back text-h2 cursor rounded center">
                                <MdCall className="icon  items-back rounded " />
                                <div >
                                    Phonebook
                                </div>

                            </div>

                            <div onClick={() => navigate('/image-to-pdf')} className="ui-items hover-u items-back text-h2 cursor rounded center">
                                <MdPictureAsPdf className="icon" />
                                <div >
                                    Image to PDF
                                </div>
                            </div>

                            <div onClick={() => navigate('/favicon-generator')} className="ui-items hover-u items-back text-h2 cursor rounded center">
                                <MdFace className="icon" />
                                <div >
                                    Favicon
                                </div>
                            </div>

                            <div onClick={() => navigate('/word-counter')} className="ui-items hover-u items-back text-h2 cursor rounded center">
                                <MdEditDocument className="icon" />
                                <div >
                                    Word counter
                                </div>
                            </div>

                            <div onClick={() => navigate('/typing-master')} className="ui-items hover-u items-back text-h2 cursor rounded center">
                                <MdKeyboard className="icon" />
                                <div >
                                    Typing master
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="container_size p-3">
                    <div class="aooz-home">
                        <div class="aooz-container">
                            <div class="aooz-content">
                                <h1>
                                    AOOZ.in<br />
                                    <span>Accounting Online Operations Zone</span>
                                </h1>

                                <p class="aooz-tagline">
                                    Simplify Accounting. Streamline Operations. Grow Faster.
                                </p>

                                <p class="aooz-description">
                                    AOOZ.in is a complete cloud-based accounting and business management
                                    software with web and mobile apps. Manage payments, inventory,
                                    stock, staff attendance, and generate online shareable receipts —
                                    all from one powerful platform.
                                </p>

                                <div class="aooz-buttons">
                                    <a href="#" class="btn-primary">Get Started</a>
                                    <a href="#" class="btn-secondary">Request Demo</a>
                                </div>
                            </div>

                            <div class="aooz-card">
                                <ul>
                                    <li>✔ Smart Accounting & Ledgers</li>
                                    <li>✔ Payment & Receipt Management</li>
                                    <li>✔ Inventory & Stock Control</li>
                                    <li>✔ Staff & Attendance System</li>
                                    <li>✔ Web & Mobile Access</li>
                                </ul>
                            </div>

                        </div>
                    </div>

                </div>

            </div>

        </div>
    );
}
